import React, { useState } from 'react';
import SectionHeader from './SectionHeader';
import { subscriptions } from '../data';
import SafeIcon from '../common/SafeIcon';

const Subscriptions = ({ onAddToCart }) => {
  const [addingId, setAddingId] = useState(null);

  const handleSubscribe = (sub) => {
    setAddingId(sub.id);
    setTimeout(() => {
      onAddToCart({ ...sub, name: sub.title, price: parseFloat(sub.price) });
      setAddingId(null);
    }, 600);
  };

  return (
    <section className="py-24 md:py-32 bg-cream-dark" id="subscriptions">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeader 
          title="The Atlas Club" 
          subtitle="Your favorite roasts, delivered on your schedule."
          icon="Repeat"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20">
          {subscriptions.map((sub, index) => (
            <div 
              key={sub.id} 
              className={`flex flex-col bg-cream-paper p-10 border transition-all duration-500 focus-within:ring-4 focus-within:ring-moss/20 ${
                index === 1 
                  ? 'border-moss shadow-2xl scale-105 z-10 relative' 
                  : 'border-gray-200 shadow-lg hover:shadow-xl'
              }`}
            >
              {index === 1 && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-moss text-cream text-[10px] font-bold uppercase tracking-[0.2em] px-6 py-2 rounded-full shadow-xl">
                  The Gold Standard
                </div>
              )}
              
              <div className="mb-8">
                <h3 className="font-serif text-3xl font-bold mb-4 text-espresso">{sub.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed italic">{sub.desc}</p>
              </div>
              
              <div className="mb-10 flex items-baseline gap-1">
                <span className="text-5xl font-serif font-bold text-espresso">${sub.price}</span>
                <span className="text-gray-400 font-bold uppercase tracking-widest text-[10px]">{sub.frequency}</span>
              </div>
              
              <ul className="space-y-5 mb-12 flex-1">
                {sub.features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-4 text-sm text-gray-700 font-medium">
                    <div className="mt-1 shrink-0 bg-moss/10 rounded-full p-1" aria-hidden="true">
                      <SafeIcon name="Check" className="text-moss text-xs" />
                    </div>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              
              <button 
                onClick={() => handleSubscribe(sub)}
                disabled={addingId === sub.id}
                aria-label={`Subscribe to ${sub.title}`}
                className={`w-full py-5 font-bold uppercase tracking-[0.2em] text-[10px] transition-all duration-300 cursor-pointer focus:outline-none focus-visible:ring-4 focus-visible:ring-moss/50 disabled:opacity-80 ${
                  index === 1 
                    ? 'bg-moss text-cream hover:bg-moss-light shadow-lg' 
                    : 'bg-espresso text-cream hover:bg-espresso-light'
                }`}
              >
                {addingId === sub.id ? (
                  <span className="flex items-center justify-center gap-2"><SafeIcon name="Loader" className="animate-spin" /> Processing...</span>
                ) : 'Start Your Journey'}
              </button>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <p className="text-gray-500 text-sm mb-6 max-w-2xl mx-auto italic">
            "Switching to BrewAtlas was the best decision for my morning routine. The freshness is incomparable."
          </p>
          <div className="flex justify-center items-center gap-4">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=100" className="w-10 h-10 rounded-full object-cover grayscale" alt="Mark Thompson" />
            <div className="text-left">
              <p className="text-xs font-bold uppercase tracking-widest">Mark Thompson</p>
              <div className="flex text-amber-500 text-[10px]" aria-label="5 out of 5 stars">
                {[1,2,3,4,5].map(i => <SafeIcon key={i} name="Star" className="fill-current" />)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscriptions;